export const noManageInboxesPermissionTooltipLabel = (
  <>
    You don&#39;t have access to this feature.
    <br />
    Ask an admin to give you this permission: Can manage inboxes.
  </>
)

export const noManageBillingPermissionTooltipLabel = (
  <>
    You don&#39;t have access to this feature.
    <br />
    Ask an admin to give you this permission: Can manage billing.
  </>
)
